function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-fill",
  d: "M13 3v4H7a3 3 0 00-3 3v7a3 3 0 003 3h21v4H6a6 6 0 01-6-6V9a6 6 0 016-6h7z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-stroke",
  d: "M12.5 3.5H6A5.5 5.5 0 00.5 9v9A5.5 5.5 0 006 23.5h21.5v-3H7A3.5 3.5 0 013.5 17v-7A3.5 3.5 0 017 6.5h5.5v-3z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-fill",
  d: "M20 23h5v47h-5z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-stroke",
  d: "M20.5 23.5h4v46h-4z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-fill",
  d: "M10.614 32C8.964 32 7 27.851 7 21.5S8.963 11 10.614 11h24.772C37.036 11 39 15.149 39 21.5S37.037 32 35.386 32H10.614z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-stroke",
  d: "M10.614 31.5h24.772c1.435 0 3.114-4.41 3.114-10s-1.68-10-3.114-10H10.614c-1.435 0-3.114 4.41-3.114 10s1.68 10 3.114 10z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-fill",
  d: "M11.73 10C10.774 10 10 7.761 10 5s.774-5 1.73-5h14.54C27.226 0 28 2.239 28 5s-.774 5-1.73 5H11.73z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-stroke",
  d: "M11.73 9.5h14.54c.535 0 1.23-2.008 1.23-4.5S26.805.5 26.27.5H11.73C11.195.5 10.5 2.508 10.5 5s.695 4.5 1.23 4.5zM43.023 58.493c-5.12 0-5.131 4-10.25 4-5.12 0-5.131-4-10.25-4-5.12 0-5.131 4-10.25 4-5.12 0-5.12-4-10.25-4"
}));

function SvgRoomWellPump(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 70,
    viewBox: "0 0 44 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomWellPump);
export default __webpack_public_path__ + "static/media/RoomWellPump.917d094d.svg";
export { ForwardRef as ReactComponent };